import { Box, Flex, Image } from "@chakra-ui/react";
import { CenteredContent } from "../../../../../components/CenteredContent";
import { CONTENT_WIDTH } from "../../../../../constants/Layout";
import {
  MENU_HEADER_IMAGES,
  MENU_HEADER_IMAGE_FALLBACK,
} from "../../../../../constants/Menus";
import { Z_INDEX } from "../../../../../constants/zIndex";
import { useDelayedSetState } from "../../../../../hooks/useDelayedCall";
import { SubMenuItem } from "./SubMenuItem";
import { TOP_BAR_HEIGHT } from "./TopBar/TopBar";

const LOGO_WIDTH = "192px";
const LOGO_MARGIN = "32px";

/**
 * @typedef {Object} Props
 * @property {number} index
 * @property {boolean} isActive
 * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
 * @property {(index: number | null) => void} setActivePanelIdFromPanel
 */
/**
 * @param {Props} props
 */
export function Panel({
  index,
  isActive,
  menuItem,
  setActivePanelIdFromPanel,
}) {
  const src =
    (menuItem?.role ? MENU_HEADER_IMAGES[menuItem.role]?.src ?? null : null) ??
    MENU_HEADER_IMAGE_FALLBACK;

  const { delayedCall, cancelDelayedCall } = useDelayedSetState();

  return (
    <Box
      onMouseEnter={() => {
        setActivePanelIdFromPanel(index);
      }}
      onMouseLeave={() => {
        setActivePanelIdFromPanel(null);
      }}
      onFocus={() => {
        setActivePanelIdFromPanel(index);
      }}
      visibility={isActive ? "visible" : "hidden"}
      opacity={isActive ? 1 : 0}
      transform={isActive ? "translateY(0)" : "translateY(-10px)"}
      transition="opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease"
      position="absolute"
      top="calc(100% - 16px)"
      left="0"
      right="0"
      backgroundColor="#fff"
      zIndex={Z_INDEX.HEADER_PANEL}>
      <CenteredContent maxWidth="1920px">
        <Flex h={`calc(100dvh - ${TOP_BAR_HEIGHT} - 100px)`} overflow="hidden">
          <Box
            flexShrink={0}
            width={`calc((100% - ${CONTENT_WIDTH}) / 2 + ${LOGO_WIDTH} + ${LOGO_MARGIN})`}>
            {src && (
              <Image src={src} alt="" w="full" h="full" objectFit="cover" />
            )}
          </Box>

          <Box w="full" h="full">
            <Box
              w="full"
              overflowY="auto"
              maxW={`calc(${CONTENT_WIDTH} - ${LOGO_WIDTH} - ${LOGO_MARGIN})`}
              pb="2rem"
              pl="1.5rem"
              onMouseLeave={() => {
                delayedCall(() => {
                  setActivePanelIdFromPanel(null);
                }, 200);
              }}
              onMouseEnter={() => {
                cancelDelayedCall();
              }}>
              <Box
                sx={{
                  columnCount: { base: 1, md: 2, lg: 3 },
                  columnGap: "2rem",
                }}>
                {menuItem.children.map((menuItem, index) => (
                  <Box sx={{ breakInside: "avoid" }} key={index}>
                    <Box pt="1.5rem">
                      <SubMenuItem menuItem={menuItem} depth={0} />
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Flex>
      </CenteredContent>
    </Box>
  );
}
